/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Элемент расписания
 */
export type CheckOutScheduleItem = {
  /**
   * День недели
   */
  day: CheckOutScheduleItem.Day
  /**
   * Время отправления
   */
  time: string
  /**
   * Срок доставки, ч
   */
  duration: number
}
export namespace CheckOutScheduleItem {
  /**
   * День недели
   */
  export enum Day {
    MON = 'mon',
    TUE = 'tue',
    WED = 'wed',
    THU = 'thu',
    FRI = 'fri',
    SAT = 'sat',
    SUN = 'sun'
  }
}
